import { create } from 'zustand'
import { User as FirebaseUser } from 'firebase/auth'
import type { User, Organization, UserRole } from '@/types'

interface AuthState {
  user: FirebaseUser | null
  userData: User | null
  userRole: UserRole | null
  organizations: Organization[]
  currentOrg: Organization | null
  loading: boolean
  setUser: (user: FirebaseUser | null) => void
  setUserData: (userData: User | null) => void
  setUserRole: (role: UserRole | null) => void
  setOrganizations: (orgs: Organization[]) => void
  setCurrentOrg: (org: Organization | null) => void
  setLoading: (loading: boolean) => void
  logout: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  userData: null,
  userRole: null,
  organizations: [],
  currentOrg: null,
  loading: true,
  setUser: (user) => set({ user }),
  setUserData: (userData) => set({ userData }),
  setUserRole: (userRole) => set({ userRole }),
  setOrganizations: (organizations) => set({ organizations }),
  setCurrentOrg: (currentOrg) => set({ currentOrg }),
  setLoading: (loading) => set({ loading }),
  logout: () =>
    set({
      user: null,
      userData: null,
      userRole: null,
      organizations: [],
      currentOrg: null,
      loading: false,
    }),
}))
